export default "__VITE_ASSET__Bmp7WruB__"